import React from "react";
import classNames from "classnames";
import { XMarkIcon } from "@heroicons/react/24/outline";

import { CollapsibleSidebarProps } from "./types";

export const CollapsibleSidebar = (props: CollapsibleSidebarProps) => {
  React.useLayoutEffect(() => {
    const addFixedToBody = () => {
      document.body.style.position = "fixed";
      document.body.style.top = "0";
      document.body.style.left = "0";
      document.body.style.right = "0";
      document.body.style.bottom = "0";
    };

    const removeFixedFromBody = () => {
      document.body.style.position = "";
    };

    if (props.show) {
      addFixedToBody();
    } else {
      removeFixedFromBody();
    }

    return () => {
      removeFixedFromBody();
    };
  }, [props.show]);

  return (
    <>
      {/* Overlay that closes the sidebar on click */}
      {props.show && (
        <div
          onClick={() => props.setShow(false)}
          className="top-0 right-0 w-screen h-screen bg-black !bg-opacity-50 fixed inset-0 z-30"
        />
      )}

      <div
        className={classNames(
          "top-0 right-0 bg-white border-l fixed h-full z-40 ease-in-out duration-300 overflow-y-auto p-6 sm:p-[40px] shadow-lg",
          props.show ? "translate-x-0" : "translate-x-full",
          props?.style?.container ?? "w-[80%] sm:w-[35vw] min-w-[300px] sm:min-w-[500px]"
        )}
      >
        {!!props?.title && (
          <div className="flex justify-between items-center text-[#343F59] text-lg  sm:text-xl">
            <p>{props.title}</p>
            <XMarkIcon
              className="w-5 h-5 cursor-pointer"
              onClick={() => props.setShow(false)}
            />
          </div>
        )}
        {props.children}
      </div>
    </>
  );
};
